import React from 'react';
import { TYPE_TITLE_IMAGE } from '../../../constants/constant';
import { TEXT_KEYS } from '../../../constants/textKeys';
import IMAGES_PATH from '../../../Images';
import { t } from '../../../translation/translation';
import TitleImage from '../../common/TitleImage';
import './style.css'

const SectionModuleEURegulation = () => {

    const title_1 = <h2>{t(TEXT_KEYS.EU_REGULATION_SECTION_MODULE_TITLE_1_1)} <h2 className='text-blue'>{t(TEXT_KEYS.EU_REGULATION_SECTION_MODULE_TITLE_1_2)}</h2> {t(TEXT_KEYS.EU_REGULATION_SECTION_MODULE_TITLE_1_3)}</h2>
    const title_2 = <h2>{t(TEXT_KEYS.EU_REGULATION_SECTION_MODULE_TITLE_2_1)} <h2 className='text-blue'>{t(TEXT_KEYS.EU_REGULATION_SECTION_MODULE_TITLE_2_2)}</h2> {t(TEXT_KEYS.EU_REGULATION_SECTION_MODULE_TITLE_2_3)}</h2>
    const description = <>
        <p>{t(TEXT_KEYS.EU_REGULATION_SECTION_MODULE_DESCRIPTION_1_1)}</p>
        <ul>
            <li>{t(TEXT_KEYS.EU_REGULATION_SECTION_MODULE_DESCRIPTION_1_2)}</li>
            <li>{t(TEXT_KEYS.EU_REGULATION_SECTION_MODULE_DESCRIPTION_1_3)}</li>
            <li>{t(TEXT_KEYS.EU_REGULATION_SECTION_MODULE_DESCRIPTION_1_4)}</li>
            <li>{t(TEXT_KEYS.EU_REGULATION_SECTION_MODULE_DESCRIPTION_1_5)}</li>
        </ul>
    </>


    return (
        <div className='section'>
            <TitleImage
                title={title_1}
                subtitle={description}
                imagePath={IMAGES_PATH.IMAGE_EU_REGULATION_1}
                type={TYPE_TITLE_IMAGE.ALTERNATIVE}
            />
            <TitleImage
                title={title_2}
                subtitle={t(TEXT_KEYS.EU_REGULATION_SECTION_MODULE_DESCRIPTION_2_1)}
                imagePath={IMAGES_PATH.IMAGE_EU_REGULATION_2}
                inverted={true}
                type={TYPE_TITLE_IMAGE.ALTERNATIVE}
            />
        </div>
    );
};

export default SectionModuleEURegulation;